import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";

import { KIOSK_COMMUNICATION_EVENT_TYPES } from "../../../../../../util/communication_statuses";

import "./index.scss";

const Signature = ({ events }) => {
  if (!events?.length) return null;

  const event = events.find(e => e.type === KIOSK_COMMUNICATION_EVENT_TYPES.CHECK_IN_ANSWERED);
  if (!event?.customer_signature) return null;

  return (
    <div className="kiosk-comm-signature">
      {event.customer_name && (
        <div className="kiosk-comm-signature-name">
          <FontAwesomeIcon icon={faUser} className="i-green" />
          <span>{event.customer_name}</span>
        </div>
      )}
      <div className="kiosk-comm-signature-img-wrapper">
        <img src={event.customer_signature} alt="signature" className="kiosk-comm-signature-img" />
      </div>
    </div>
  );
};

export default Signature;
